import {
  Show,
  SimpleShowLayout,
  TextField,
  NumberField,
  DateField,
  ReferenceArrayField,
  Datagrid,
  ArrayField,
  FunctionField,
} from 'react-admin'
import Grid from '@mui/material/Grid'
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'

export const SubscriptionRefundDetailShow = props => (
  <Show {...props}>
    <SimpleShowLayout>
      <Grid container spacing={2}>
        <Grid item xs={4}>
          <TextField source="id" />
        </Grid>
        <Grid item xs={4}>
          <TextField source="refundId" />
        </Grid>
        <Grid item xs={4}>
          <TextField source="subscriptionId" />
        </Grid>
        <Grid item xs={4}>
          <TextField source="userId" />
        </Grid>
        <Grid item xs={4}>
          <NumberField source="totalCreditsReceived" />
        </Grid>
        <Grid item xs={4}>
          <NumberField source="totalCreditsUsed" />
        </Grid>
        <Grid item xs={4}>
          <NumberField source="allowedCredits" />
        </Grid>
        <Grid item xs={4}>
          <NumberField source="overUsedCredits" />
        </Grid>
        <Grid item xs={4}>
          <NumberField source="publisherCommissionDeducted" />
        </Grid>
        <Grid item xs={4}>
          <DateField source="createdAt" />
        </Grid>
        <Grid item xs={4}>
          <DateField source="updatedAt" />
        </Grid>
        <Grid item xs={12}>
          <FunctionField
            label="Inactivated Credit IDs"
            render={record =>
              record.inactivatedCreditIds
                ? record.inactivatedCreditIds.join(', ')
                : ''
            }
          />
        </Grid>
      </Grid>

      <Box mt={3}>
        <Typography variant="h6">Disabled Purchase Histories</Typography>
        <ReferenceArrayField
          source="disabledPurchaseHistoryIds"
          reference="purchase-histories"
          label="">
          <Datagrid bulkActionButtons={false} rowClick={false}>
            <TextField source="id" />
            <TextField source="productName" />
          </Datagrid>
        </ReferenceArrayField>
      </Box>

      <Box mt={3}>
        <Typography variant="h6">Commission Details</Typography>
        <ArrayField source="commissionDetails" label="">
          <Datagrid bulkActionButtons={false} rowClick={false}>
            <NumberField source="amount" />
            <NumberField source="commission" />
            <TextField source="publisherId" />
            <TextField source="purchaseHistoryId" />
            <TextField source="purchaseCommissionId" />
          </Datagrid>
        </ArrayField>
      </Box>
    </SimpleShowLayout>
  </Show>
)

export default SubscriptionRefundDetailShow
